import RemoteCollection from "./RemoteCollection";

class PaginatedRemoteCollection extends RemoteCollection {
  whenLoaded(data) {
    super.whenLoaded(data);
    this.total = data.meta.total;
    this.current_page = data.meta.current_page;
    this.last_page = data.meta.last_page;
    this.per_page = data.meta.per_page;
    return this;
  }

  resolveParams(params) {
    return Object.assign(
      {
        "page[size]": this.per_page,
        "page[number]": this.current_page
      },
      params
    );
  }

  perPage(size) {
    this.per_page = size;
    return this;
  }

  changePage(page) {
    this.current_page = page;
    this.load();
  }

  hasPreviousPage() {
    return this.current_page > 1;
  }

  hasNextPage() {
    return this.current_page < this.last_page;
  }
}

export default PaginatedRemoteCollection;
